import { ApiError, type ApiClient } from '../../api/client';
import type { StaffingWorker } from '../../api/types';
import type { RewardWorkerOption, RewardsApi } from '../../features/rewards/public';

export function rewardWorkerOption(worker: StaffingWorker): RewardWorkerOption {
  const name = worker.descriptor?.trim() || '이름 미등록';
  const workerNumber = worker.workerId?.trim();
  const organization = worker.primaryJob?.supervisoryOrganization?.descriptor?.trim();
  return {
    id: worker.id,
    label: [
      name,
      workerNumber && workerNumber !== name ? workerNumber : undefined,
      organization,
    ].filter(Boolean).join(' · '),
  };
}

export function createRewardsHttpAdapter(client: ApiClient): RewardsApi {
  return {
    async listWorkers(search, asOf) {
      return (await client.listAllWorkers(search, asOf)).data.map(rewardWorkerOption);
    },
    async listAllWorkers() {
      return (await client.listAllWorkers()).data.map(rewardWorkerOption);
    },
    getWorkerRewards(workerId) {
      return client.getWorkerRewards(workerId);
    },
    createRewardChange(input, idempotencyKey) {
      return client.createRewardChange(input, idempotencyKey);
    },
    submitRewardChange(changeId, idempotencyKey) {
      return client.submitRewardChange(changeId, idempotencyKey);
    },
    isDefinitiveRequestFailure(reason) {
      return reason instanceof ApiError;
    },
  };
}
